import {bardiTypes} from "./type";
import {BaseReducer} from "../../reducers/base";

const types = bardiTypes;

const initialState = {
    datas: [],
    data: {},
    isLoading: false,
    success: false,
    msg: {},
};

const bardiReducer = (state = initialState, action) => {
    const baseClass = new BaseReducer(types, state, action);

    return baseClass.baseReducer();
};

export default bardiReducer;
